import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconGpsComponent } from "./med-icon-gps.component";

@NgModule({
  declarations: [
    MedIconGpsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconGpsComponent,
  ],
})
export class MedIconGpsModule { }
